import PlanetManage from "./planet-manage";

export default PlanetManage